import React, { Component, Fragment } from "react"
import { tableHeader } from "../../services/common/options"
import QrCode from "../Common/QrCode"
import magnumLogo from "../../assets/images/magnum_logo.png";
class PrintFabricPage extends Component {
  state = {
    selectedData: this.props.selectedData,
    column: this.props.column,
    tableHeaderData: this.props.tableHeaderData
  }

  componentWillReceiveProps = props => {
    this.setState({
      selectedData: props.selectedData,
      column: props.column,
      tableHeaderData: props.tableHeaderData
    })
  }

  render() {
    const { selectedData, column, tableHeaderData } = this.state

    return (
      <Fragment>
        <div className="print-div">
          <style>
            {`@media print {.w-100{width:100%;}
             .print-h-w:not(:first-child) { margin-top:7px;}
              body{font-family: 'Lato', sans-serif;font-size:1rem;}
              .print-h-w{height:98%;width:100%;border:1px solid black;page-break-after: always; word-wrap: break-word;}
              .td-border{border-bottom:1px solid black;width:100%;}
              table > tbody > tr:nth-child(odd){background: transparent;}
              table > tbody > tr td{font-size:11px;vertical-align:top;padding:0px 0px;max-width:100%;}
              .border-bl{border:1px solid black;}
              .text-right{text-align:right}.text-left{text-align:left}.text-center{text-align:center}
              .text-center{text-align:center;}.f-15{font-size:10px;}.title-main{padding:0px 0px 3px 0px;}.qr-wrap{padding:0px;height:100%}.width-30{width:20%;}.width-70{width:80%;}}`}
          </style>
          <div class="table-container">
            {selectedData.map(val => {
              return (
                <Fragment>
                  <div className="overflow print-h-w">
                    <table className="borderless-table w-100">
                      <tbody>
                        <tr>
                          <td colSpan="4" className="text-center td-border">
                            <div className="title-main">
                              <b>{"MAGNUM CLOTHING PVT LTD"}</b>
                            </div>
                          </td>
                        </tr>
                        <tr className="border-0">
                          <td rowspan="10" className="qr-wrap text-center">
                            <div
                              style={{
                                height: "600px%",
                                maxWidth: "600px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                margin: "20px 0"
                              }}
                            >
                              <div className="my-2 nopadding border-1">
                                {/* <img src="https://magnum-clothing.s3.ap-south-1.amazonaws.com/styleReference/a115ff92-25d9-46f5-b4d6-a228b9e2022d.png" style={{ "width": '60px', height: "60px" }} /> */}
                                <img src={magnumLogo} style={{ "width": '60px', height: "60px" }} />

                              </div>
                              {/* <QrCode qr={val.qr} /> */}
                            </div>
                            <div className="text-center f-15">
                              <b>FABRIC NO</b> <br />
                              {val.fabricNumber}
                            </div>
                          </td>

                          {tableHeaderData.map(data => {
                            if (
                              data.tableKeyName !== "qr" &&
                              data.tableKeyName !== "fabricNumber"
                            ) {
                              if (column[data.tableKeyName]) {
                                return (
                                  <tr className="border-0">
                                    <td className="" style={{ "padding": "2px 0px" }}>
                                      <b>{data.tableName === "CONSTRUCTION" ? "CONSTRUCT." : data.tableName}:</b>
                                    </td>
                                    <td className="">
                                      {val[data.tableKeyName]}
                                    </td>
                                  </tr>
                                )
                              } else {
                                return (
                                  <tr className="border-0">
                                    <td className=""> :</td>

                                    <td className=""> </td>
                                  </tr>
                                )
                              }
                            }
                          })}
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </Fragment>
              )
            })}
          </div>
        </div>
      </Fragment>
    )
  }
}

export default PrintFabricPage


// WEBPACK FOOTER //
// ./src/components/PrintFabricPage/index.js